<script setup>
import UserProfilePhoto from 'components/UserProfilePhoto.vue';
import { useAuthStore } from 'stores/auth-store';

const authStore = useAuthStore();
</script>

<template>
    <div class="user-menu-toggle flex">
        <q-btn aria-label="Open user menu" color="white" flat text-color="separator" title="Open user menu" unelevated>
            <UserProfilePhoto :src="authStore.user?.photoUrl" size="36px" bordered/>
        </q-btn>
    </div>
</template>

<style lang="scss" scoped>
.user-menu-toggle .q-btn {
    aspect-ratio: 1/1;
    height: 36px;
    padding: 0;
    width: auto;

    .q-icon {
        // Correction to icon misalignment within button
        margin-left: 1px;
    }
}
</style>
